import { render, staticRenderFns } from "./GenericBox.vue?vue&type=template&id=0db7887c&scoped=true"
import script from "./GenericBox.vue?vue&type=script&lang=js"
export * from "./GenericBox.vue?vue&type=script&lang=js"
import style0 from "./GenericBox.vue?vue&type=style&index=0&id=0db7887c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7887c",
  null
  
)

export default component.exports